// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './components/leiaute/Header';
import SideNav from './components/leiaute/SideNav';
import Content from './components/leiaute/Content';

import PDVPage from './pages/vendas/PDVPage';
import PesqNotasPage from './pages/vendas/PesqNotasPage';
import PesqNotasItemPage from './pages/vendas/PesqNotasItemPage';
import PesqNotaItemEntradaPage from './pages/estoque/PesqNotaItemEntradaPage';
import RecebimentoConsultaPage from './pages/financeiro/RecebimentoConsultaPage';
import DashFinanceiro from './pages/financeiro/DashFinanceiro';
import { DashFinanceiroProvider } from './contexts/financeiro/DashFinanceiroContext';
import { PrinterProvider } from './contexts/geral/PrinterContext';
import Login from './pages/geral/Login';
import { useToken } from './contexts/geral/TokenContext';
import { ConfigModuloProvider, useConfigModulo } from './contexts/administrativo/ConfigModuloContext';
import { ConfigDFeProvider } from './contexts/administrativo/ConfigDFeContext';
import { ClienteProvider } from './contexts/pessoas/ClienteContext';
import { EmpresaProvider } from './contexts/administrativo/EmpresaContext';
import { CidadeProvider } from './contexts/geral/CidadeContext';
import { FilialProvider } from './contexts/administrativo/FilialContext';
import { useFilial } from './contexts/administrativo/FilialContext';
import { FormaPagProvider } from './contexts/financeiro/FormaPagContext';
import { ContaBancoProvider } from './contexts/financeiro/ContaBancoContext';
import { RecebimentoProvider } from './contexts/financeiro/RecebimentoContext';
import { AssinaturaProvider } from './contexts/financeiro/AssinaturaContext';
import PesqResumoCaixaPage from './pages/caixas/PesqResumoCaixaPage';
import RelatorioProdutos from './pages/produtos/produtos/RelatorioProdutos';
import PainelPedido from './pages/pedidos/PainelPedido';
import PesqPedidoPage from './pages/pedidos/PesqPedidoPage';
import PesqPedidoItemPage from './pages/pedidos/PesqPedidoItemPage';
import PedidoProviders from './providers/PedidoProviders';
import ProdutosProvider from './providers/ProdutoProviders';
import ControleBarProviders from './providers/ControleBarProviders';
import MesaPage from './pages/controleBar/mesas/MesaPage';
import MesaControlePage from './pages/controleBar/mesas/MesaControlePage';
import { FornecedorProvider } from './contexts/pessoas/FornecedorContext';
import EntradaNotaPage from './pages/estoque/EntradaNotaPage';
import ConsultaEntradaNotaPage from './pages/estoque/ConsultaEntradaNotaPage';
import NotaProviders from './providers/NotaProvider';
import { NaturezaProvider } from './contexts/vendas/NaturezaContext';
import { PDVProvider } from './contexts/vendas/PDVContext';
import { CaixaResumoProvider } from './contexts/caixas/CaixaResumoContext';
import { CaixaMovProvider } from './contexts/caixas/CaixaMovContext';
import { CaixaProvider } from './contexts/caixas/CaixaContext';
import { NotaPagProvider } from './contexts/vendas/NotaPagContext';
import { PrintNFCeProvider } from './contexts/geral/PrintNFCeContext';
import { ConfigWhatsProvider } from './contexts/pedidos/ConfigWhatsContext';
import { PrinterCaixaProvider } from './contexts/geral/PrinterCaixaContext';
import { PrinterComandaProvider } from './contexts/geral/PrinterComandaContext';
import ImportarXMLPage from './pages/estoque/ImportarXMLPage';
import ConsultaProdutoPage from './pages/produtos/produtos/ConsultaProdutoPage';
import PesqEstoquePage from './pages/estoque/PesqEstoquePage';
import { useUser } from './contexts/geral/UserContext';
import MonitorImpressaoBackground from './components/geral/MonitorImpressaoBackground';
import MonitorImpressaoPage from './pages/geral/MonitorImpressaoPage';
import FiltrarComandasPage from './pages/controleBar/comandas/FiltrarComandasPage';
import PesqComandaPage from './pages/controleBar/comandas/PesqComandaPage';
import DashPedidos from './pages/pedidos/DashPedidos';
import DashProdutos from './pages/produtos/produtos/DashProdutos';
import DashCliente from './pages/pessoas/clientes/DashCliente';
import WhatsAppWeb from './pages/pedidos/WhatsappWeb';
import { WhatsAppWebProvider } from './contexts/pedidos/WhatsappWebContext';
import { ChatContatoProvider } from './contexts/pedidos/ChatContatoContext';
import { SSEProvider } from './contexts/geral/SSEContext';
import { UsuarioProvider } from './contexts/geral/UsuarioContext';
import UsuarioCad from './pages/geral/UsuarioCad';
import RelatorioVendasGarcomPage from './pages/pedidos/RelatorioVendasGarcomPage';
import AssinaturaConsultaPage from './pages/financeiro/AssinaturaConsultaPage';
import LeadCaptacaoConsultaPage from './pages/geral/leads/LeadCaptacaoConsultaPage';
import AssinaturaPixPage from './pages/financeiro/AssinaturaPixPage';
import AssinaturaStatusModal from './pages/financeiro/AssinaturaStatusModal';
import { useMessage } from './contexts/geral/MessageContext';
import { buscarStatusCliente } from './services/financeiro/AssinaturaService';
import MDFeProviders from './providers/MDFeProviders';
import MDFeEmissaoPage from './pages/fiscal/mdfe/MDFeEmissaoPage';
import MDFeConsultaPage from './pages/fiscal/mdfe/MDFeConsultaPage';
import { OrdemServicoProvider } from './contexts/servicos/OrdemServicoContext';
import { EquipamentoClienteProvider } from './contexts/servicos/EquipamentoClienteContext';
import { TipoEquipamentoProvider } from './contexts/servicos/TipoEquipamentoContext';
import { TecnicoResponsavelProvider } from './contexts/servicos/TecnicoResponsavelContext';
import { PrinterOSProvider } from './contexts/geral/PrinterOSContext';
import OrdemServicoPage from './pages/servicos/ordensServico/OrdemServicoPage';
import OrdemServicoConsultaPage from './pages/servicos/ordensServico/OrdemServicoConsultaPage';
import CadastrosServicoPage from './pages/servicos/cadastros/CadastrosServicoPage';
import TecnicoResponsavelPage from './pages/servicos/tecnicos/TecnicoResponsavel';
import { OrcamentoProvider } from './contexts/orcamentos/OrcamentoContext';
import OrcamentoPage from './pages/orcamentos/OrcamentoPage';
import OrcamentoConsultaPage from './pages/orcamentos/OrcamentoConsultaPage';

// ✅ ProtectedRoute
const ProtectedRoute = ({ children }) => {
  const { token } = useToken();
  return (token !== 'null' && token) ? children : <Navigate to="/login" />;
};

// ✅ Tela loading simples (pode personalizar)
const FullScreenLoading = ({ text = "Carregando..." }) => (
  <div className="login-container">
    <div className="login-loading">
      <div
        className="spinner-border"
        role="status"
        style={{ width: '3rem', height: '3rem', color: '#3d6df2' }}
      />
      <strong className="login-loading-text">
        {text}
      </strong>
    </div>
  </div>
);


// ✅ Aqui é o pulo do gato: componente interno que JÁ está dentro do Provider
const AuthenticatedLayout = ({ token, isSideNavOpen, setIsSideNavOpen, toggleSideNav, isMobile }) => {
  const { user, logout } = useUser();
  const { loading: filialLoading, filialLogin } = useFilial();
  const { setToken, setTokenExpires } = useToken();
  const { showMessage } = useMessage();
  const navigate = useNavigate();
  const statusClienteConsultadoRef = useRef(null);
  const [showCobrancaStatusModal, setShowCobrancaStatusModal] = useState(false);
  const [cobrancaStatus, setCobrancaStatus] = useState(null);
  const [showModalUsuario, setShowModalUsuario] = useState(false);

  // ✅ agora funciona, pq está dentro de <ConfigModuloProvider>
  const { loading, ready, configModuloSel } = useConfigModulo();

  const realizarLogoff = () => {
    logout();
    setToken(null);
    setTokenExpires(null);
    navigate('/login', { replace: true });
  };

  const handleOpenUsuario = () => {
    if (isMobile) setIsSideNavOpen(false);
    setShowModalUsuario(true);
  };

  useEffect(() => {
    if (loading || !ready || filialLoading || !filialLogin?.cnpj) {
      return;
    }

    if (statusClienteConsultadoRef.current === filialLogin.cnpj) {
      return;
    }

    statusClienteConsultadoRef.current = filialLogin.cnpj;

    const consultarStatusCliente = async () => {
      try {
        const result = await buscarStatusCliente(filialLogin.cnpj);
        const status = result?.status;

        if (status === 'EmAtraso' || status === 'Bloqueado') {
          setCobrancaStatus(result);
          setShowCobrancaStatusModal(true);
          return;
        }

        if (status === 'NaoCadastrado') {
          showMessage('Cliente não cadastrado! Solicite cadastro para liberar o acesso.', 'danger', realizarLogoff);
        }
      } catch (error) {
        console.error('Erro ao consultar status do cliente:', error);
      }
    };

    consultarStatusCliente();
  }, [loading, ready, filialLoading, filialLogin?.cnpj, showMessage, setToken, setTokenExpires, navigate]);

  if (loading || !ready || filialLoading) {
    return <FullScreenLoading text="Carregando configurações do sistema..." />;
  }

  return (
    <div className="d-flex app-shell">
      {token !== 'null' && token && (
        <SideNav isOpen={isSideNavOpen} setIsOpen={setIsSideNavOpen} isMobile={isMobile} onOpenUsuario={handleOpenUsuario} />
      )}

      <div className="flex-grow-1 app-main" inert={isMobile && isSideNavOpen ? true : undefined}>
        {token !== 'null' && token && (
          <Header toggleSideNav={toggleSideNav} isSideNavOpen={isSideNavOpen} onOpenUsuario={handleOpenUsuario} onLogout={realizarLogoff} />
        )}

        {configModuloSel?.monitorWeb && <MonitorImpressaoBackground />}

        <Routes>
          {user?.admin && <Route path="/" element={<ProtectedRoute><Content /></ProtectedRoute>} />}
          {user?.admin && <Route path="/dashPedidos" element={<ProtectedRoute><DashPedidos /></ProtectedRoute>} />}
          {user?.admin && <Route path="/dashProdutos" element={<ProtectedRoute><DashProdutos /></ProtectedRoute>} />}
          {user?.admin && <Route path="/dashCliente" element={<ProtectedRoute><DashCliente /></ProtectedRoute>} />}
          {user?.admin && <Route path="/dashFinanceiro" element={<ProtectedRoute><DashFinanceiroProvider><DashFinanceiro /></DashFinanceiroProvider></ProtectedRoute>} />}

          <Route path="/pdv" element={<ProtectedRoute><PDVPage /></ProtectedRoute>} />
          <Route path="/entrada" element={<ProtectedRoute><EntradaNotaPage /></ProtectedRoute>} />
          <Route path="/entrada/:notaId" element={<ProtectedRoute><EntradaNotaPage /></ProtectedRoute>} />
          <Route path="/importarXML" element={<ProtectedRoute><ImportarXMLPage /></ProtectedRoute>} />
          <Route path="/consultaEntradas" element={<ProtectedRoute><ConsultaEntradaNotaPage /></ProtectedRoute>} />
          <Route path="/consultaProduto" element={<ProtectedRoute><ConsultaProdutoPage /></ProtectedRoute>} />
          <Route path="/pesqEstoque" element={<ProtectedRoute><PesqEstoquePage /></ProtectedRoute>} />

          <Route path="/pesqNotas" element={
            <ProtectedRoute>
              <CaixaResumoProvider>
                <CaixaMovProvider>
                  <CaixaProvider>
                    <PDVProvider>
                      <NotaPagProvider>
                        <PesqNotasPage />
                      </NotaPagProvider>
                    </PDVProvider>
                  </CaixaProvider>
                </CaixaMovProvider>
              </CaixaResumoProvider>
            </ProtectedRoute>
          } />

          <Route path="/pesqNotasItem" element={<ProtectedRoute><PesqNotasItemPage /></ProtectedRoute>} />
          <Route path="/PesqNotaItemEntradaPage" element={<ProtectedRoute><PesqNotaItemEntradaPage /></ProtectedRoute>} />

          <Route path="/monitorImpressao" element={<ProtectedRoute><MonitorImpressaoPage /></ProtectedRoute>} />
          <Route path="/pesqCaixa" element={<ProtectedRoute><PesqResumoCaixaPage /></ProtectedRoute>} />
          <Route path="/recebimento" element={<ProtectedRoute><RecebimentoProvider><RecebimentoConsultaPage /></RecebimentoProvider></ProtectedRoute>} />
          <Route path="/fatura/consultar" element={<ProtectedRoute><AssinaturaConsultaPage /></ProtectedRoute>} />
          <Route path="/leads/consultar" element={<ProtectedRoute><LeadCaptacaoConsultaPage /></ProtectedRoute>} />
          <Route path="/pix/assinatura/:token" element={<AssinaturaPixPage />} />
          <Route path="/relProdutos" element={<ProtectedRoute><RelatorioProdutos /></ProtectedRoute>} />
          <Route path="/relVendasGarcom" element={<ProtectedRoute><UsuarioProvider><RelatorioVendasGarcomPage /></UsuarioProvider></ProtectedRoute>} />
          <Route path="/mdfe/emitir" element={<ProtectedRoute><MDFeEmissaoPage /></ProtectedRoute>} />
          <Route path="/mdfe/consultar" element={<ProtectedRoute><MDFeConsultaPage /></ProtectedRoute>} />
          <Route path="/ordemServico/consultar" element={<ProtectedRoute><OrdemServicoConsultaPage /></ProtectedRoute>} />
          <Route path="/ordemServico/:id" element={<ProtectedRoute><OrdemServicoPage /></ProtectedRoute>} />
          <Route path="/ordemServico" element={<ProtectedRoute><OrdemServicoPage /></ProtectedRoute>} />
          <Route path="/servicos/cadastros" element={<ProtectedRoute><CadastrosServicoPage /></ProtectedRoute>} />
          <Route path="/servicos/tecnicos" element={<ProtectedRoute><TecnicoResponsavelPage /></ProtectedRoute>} />
          <Route path="/orcamento/consultar" element={<ProtectedRoute><OrcamentoConsultaPage /></ProtectedRoute>} />
          <Route path="/orcamento/:id" element={<ProtectedRoute><OrcamentoPage /></ProtectedRoute>} />
          <Route path="/orcamento" element={<ProtectedRoute><OrcamentoPage /></ProtectedRoute>} />

          {/* Delivery */}
          <Route path="/pedido" element={<ProtectedRoute><PainelPedido /></ProtectedRoute>} />
          <Route path="/pesqPedido" element={<ProtectedRoute><PesqPedidoPage /></ProtectedRoute>} />
          <Route path="/pesqPedidoItem" element={<ProtectedRoute><PesqPedidoItemPage /></ProtectedRoute>} />
          <Route path="/whatsAppWeb" element={<ProtectedRoute><WhatsAppWebProvider><ChatContatoProvider><WhatsAppWeb /></ChatContatoProvider></WhatsAppWebProvider></ProtectedRoute>} />

          {/* Controle Atendimento Bar */}
          <Route path="/mesaPage" element={<ProtectedRoute><ControleBarProviders><MesaPage /></ControleBarProviders></ProtectedRoute>} />
          <Route path="/filtrarComandasPage" element={<ProtectedRoute><ControleBarProviders><FiltrarComandasPage /></ControleBarProviders></ProtectedRoute>} />
          <Route path="/mesaControlePage/:mesaId" element={<ProtectedRoute><ControleBarProviders><MesaControlePage /></ControleBarProviders></ProtectedRoute>} />
          <Route path="/pesqComandaPage" element={<ProtectedRoute><ControleBarProviders><PesqComandaPage /></ControleBarProviders></ProtectedRoute>} />
        </Routes>
      </div>

      {showModalUsuario && (
        <UsuarioProvider>
          <UsuarioCad show onHide={() => setShowModalUsuario(false)} />
        </UsuarioProvider>
      )}

      <AssinaturaStatusModal
        show={showCobrancaStatusModal}
        cobrancaStatus={cobrancaStatus}
        onClose={() => setShowCobrancaStatusModal(false)}
        onLogout={realizarLogoff}
      />
    </div>
  );
};

// ✅ Providers
const AuthenticatedApp = ({ token, isSideNavOpen, setIsSideNavOpen, toggleSideNav, isMobile }) => {
  return (
    <ProdutosProvider>
      <CidadeProvider>
        <EmpresaProvider>
          <FilialProvider>
            <SSEProvider>
              <ClienteProvider>
                <FornecedorProvider>
                  <ConfigModuloProvider>
                    <ConfigDFeProvider>
                    <ConfigWhatsProvider>
                      <FormaPagProvider>
                        <ContaBancoProvider>
                          <AssinaturaProvider>
                          <NaturezaProvider>
                            <NotaProviders>
                              <PedidoProviders>
                                <PrinterProvider>
                                  <PrinterCaixaProvider>
                                    <PrinterComandaProvider>
                                      <PrinterOSProvider>
                                      <PrintNFCeProvider>
                                        {/* ✅ agora o controle fica aqui dentro */}
                                        <MDFeProviders>
                                          <OrdemServicoProvider>
                                          <OrcamentoProvider>
                                          <TecnicoResponsavelProvider>
                                          <TipoEquipamentoProvider>
                                          <EquipamentoClienteProvider>
                                          <AuthenticatedLayout
                                            token={token}
                                            isSideNavOpen={isSideNavOpen}
                                            setIsSideNavOpen={setIsSideNavOpen}
                                            toggleSideNav={toggleSideNav}
                                            isMobile={isMobile}
                                          />
                                          </EquipamentoClienteProvider>
                                          </TipoEquipamentoProvider>
                                          </TecnicoResponsavelProvider>
                                          </OrcamentoProvider>
                                          </OrdemServicoProvider>
                                        </MDFeProviders>
                                      </PrintNFCeProvider>
                                      </PrinterOSProvider>
                                    </PrinterComandaProvider>
                                  </PrinterCaixaProvider>
                                </PrinterProvider>
                              </PedidoProviders>
                            </NotaProviders>
                          </NaturezaProvider>
                          </AssinaturaProvider>
                        </ContaBancoProvider>
                      </FormaPagProvider>
                    </ConfigWhatsProvider>
                    </ConfigDFeProvider>
                  </ConfigModuloProvider>
                </FornecedorProvider>
              </ClienteProvider>
            </SSEProvider>
          </FilialProvider>
        </EmpresaProvider>        
      </CidadeProvider>
    </ProdutosProvider>
  );
};

function App() {
  const { token, sessaoDisponivel } = useToken();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isSideNavOpen, setIsSideNavOpen] = useState(window.innerWidth >= 992);
  const previousMobile = useRef(window.innerWidth < 992);

  const toggleSideNav = () => setIsSideNavOpen((open) => !open);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      if (previousMobile.current !== mobile) {
        setIsMobile(mobile);
        setIsSideNavOpen(!mobile);
        previousMobile.current = mobile;
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <BrowserRouter>
      {sessaoDisponivel ? (
        <AuthenticatedApp
          token={token}
          isSideNavOpen={isSideNavOpen}
          setIsSideNavOpen={setIsSideNavOpen}
          toggleSideNav={toggleSideNav}
          isMobile={isMobile}
        />
      ) : (
        <Routes>
          <Route path="/pix/assinatura/:token" element={<AssinaturaPixPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
